export const ReportItemTypes = {
  PAGE: 'page',
  SECTION: 'section',
};
